// Import necessary dependencies from React and Material-UI
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { createTheme, ThemeProvider } from "@mui/material";
import List from '../List/List';
import Grid from '../Grid/Grid';
import "./Tabs.css";
import Grid2 from '@mui/material/Unstable_Grid2';
import Search from '../Search/Search';

/**
 * TabsComponent represents a component with tabs (Grid View and List View) for displaying cryptocurrency information.
 * @param {Array} coins - Array of cryptocurrency objects.
 * @param {string} searchText - Current value of the search input.
 * @param {function} handleSearchBar - Function to handle changes in the search input.
 * @returns {JSX.Element} - TabsComponent.
 */
export default function TabsComponent({ coins, searchText, handleSearchBar }) {
  // State to manage the active tab value
  const [value, setValue] = useState("grid");

  // Function to handle tab change
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Theme configuration for Material-UI components
  const theme = createTheme({
    palette: {
      primary: {
        main: "#3a80e9",
      },
    },
  });

  return (
    // ThemeProvider for applying the theme to Material-UI components
    <ThemeProvider theme={theme}>
      {/* TabContext to manage the state of the active tab */}
      <TabContext value={value}>
        {/* Container for search input and tabs */}
        <Grid2 container spacing={2}>
          {/* Search component with search input */}
          <Grid2 xs={12} sm={6} key={56}>
            <Search searchText={searchText} handleSearchBar={handleSearchBar} />
          </Grid2>
          {/* TabList container with tabs */}
          <Grid2 xs={12} sm={6} key={76}>
            <Box sx={{ borderBottom: 1, borderColor: '#414141' }}>
              {/* TabList with two tabs: Grid View and List View */}
              <TabList onChange={handleChange}>
                <Tab label="GRID VIEW" value="grid" sx={{ color: "white", padding: "0" }} />
                <Tab className="list-view-34" label="LIST VIEW" value="list" sx={{ color: "white", padding: "0" }} />
              </TabList>
            </Box>
          </Grid2>
        </Grid2>

        {/* TabPanel for Grid View */}
        <TabPanel value="grid" sx={{ padding: "20px 0" }}>
          {/* Grid2 container for displaying cryptocurrency information in a grid layout */}
          <Grid2 container spacing={2}>
            {/* Map through coins array and render Grid component for each coin */}
            {coins.map((coin, i) => {
              return (
                <Grid2 xs={12} sm={6} md={4} lg={3} key={i}>
                  <Grid coin={coin} index={i} key={i} />
                </Grid2>
              );
            })}
          </Grid2>
        </TabPanel>

        {/* TabPanel for List View */}
        <TabPanel value="list" sx={{ padding: "20px 0" }}>
          {/* Grid2 container for displaying cryptocurrency information in a list layout */}
          <Grid2 container spacing={0}>
            {/* Map through coins array and render List component for each coin */}
            {coins.map((coin, i) => {
              return (
                <Grid2 xs={12} key={i}>
                  <List coin={coin} index={i} key={i} />
                </Grid2>
              );
            })}
          </Grid2>
        </TabPanel>
      </TabContext>
    </ThemeProvider>
  );
}
